import { Product } from "@framework/types";
import http from "@framework/utils/http";
import { API_ENDPOINTS } from "@framework/utils/api-endpoints";
import { useQuery } from "react-query";
export const fetchProductDetails = async (id: string) => {
  const {
    data
  } = await http.get(`${API_ENDPOINTS.PRODUCT_DETAILS}/${id}`);
  return data;
};
export const useProductDetailsQuery = (slug: string) => {
  const id = slug.split('-')[0];
  return useQuery<Product, Error>([API_ENDPOINTS.PRODUCT_DETAILS, id], () => fetchProductDetails(id), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};